import { useEffect, useState } from 'react';
import { nowOffsetMinutes, toXPx } from '../../../shared/lib/schedule';
import { BOARD_LAYER } from '../model/boardLayers';

interface Props {
  /** Left edge of the time grid, i.e. the width of the sticky technician column. */
  offsetX: number;
}

/**
 * The red "now" marker, spanning every row. Only rendered on today; hidden outside the drawn hours.
 */
export const BoardCurrentTimeLine = ({ offsetX }: Props) => {
  const [minutes, setMinutes] = useState(() => nowOffsetMinutes(new Date()));

  useEffect(() => {
    const tick = () => setMinutes(nowOffsetMinutes(new Date()));
    const timer = window.setInterval(tick, 60_000);
    return () => window.clearInterval(timer);
  }, []);

  if (minutes == null) return null;

  return (
    <div
      className={`pointer-events-none absolute bottom-0 top-0 w-[1.5px] bg-red-500 ${BOARD_LAYER.marker}`}
      style={{ left: offsetX + toXPx(minutes) }}
      aria-hidden
    />
  );
};
